<section class="selected-recipients-wrapper">
  <div class="selected-recipients-header">
    <span class="title">Selected recipients ({{ selectedContactsCount }})</span>
  </div>
  <mat-divider></mat-divider>
  <div class="selected-recipients-content">
    @for (member of dataSource; track member) {
    <div class="list">
      <div class="parent-row">{{ member.name }} ({{ member.city }})</div>
      <div class="children">
        @for (contact of member.contacts; track contact) {
        <div class="child-row">
          <div class="recipient-chip">
            <span class="contact-name">{{ contact.name }}</span>
            <span class="contact-status">
              @if (contact.status === 'SHARED') { Shared by
              {{ contact.sharedByName }} at {{ contact.dateShared }}
              } @else { Pending }
            </span>
          </div>
          <mat-icon
            (click)="onRemove(member, contact)"
            class="remove-icon material-icons-outlined"
            matTooltip="Remove recipient"
            >delete</mat-icon
          >
        </div>
        }
      </div>
    </div>
    }
  </div>
</section>
